import styled from 'styled-components';

import { Flex } from 'web-styled';

export const Header = styled(Flex).attrs({
  width: 'calc(100% + 50px)',
})`
  margin: 0 -25px;
  padding: 0 0 24px 23px;
  border-bottom: 0.5px solid #c7c7cb;
`;
